<template>
  <div class="steam-list-wrapper">
    <van-sticky>
      <van-tabs v-model="active" @change="changeTabs" sticky background="#fff" title-active-color="#000">
        <van-tab v-for="(item,index) in tabList" :title="item" :key="index"></van-tab>
      </van-tabs>
    </van-sticky>

    <div class="steam-list-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadInfo">
          <div v-if="steamAssignmentList.length>0">
            <div v-for="item in steamAssignmentList" :key="item.id">
              <steam-assignment-item :assignmentItem="item" />
            </div>
          </div>
          <div v-else class="empty-state">
            <van-empty description="暂无作业数据" />
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <Tabbar></Tabbar>

  </div>
</template>
<script>
import Tabbar from "@/views/Public/tabbarTpl.vue";
import SteamAssignmentItem from "@/components/SteamComponents/steamAssignmentItem.vue";
import steamApi from "@/fetch/steamApi.js";
import { Toast } from "vant";
export default {
  components: {
    Tabbar,SteamAssignmentItem,
  },
  data()
  {
    return {
      page:1,
      active:1,
      steamAssignmentList:[],
      tabList:['全部','作业中','待签字'],
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  inject: ['reload'],
  created()
  {
    document.title = "作业记录列表";
    var type = "all";
    switch (this.active) {
      case 0://所有
        type = "all";
      break;
      case 1:
        type = "working";
      break;
      case 2:
        type = "finish";
      break;
    }
    this.getSteamAssignmentList(type,1);
  },
  methods:{
    getSteamAssignmentList(type,page)
    {
      var that = this;
      if(page == 1)
      {
        that.steamAssignmentList = [];
      }

      var openid = that.$store.state.wx_info.openid;

      let formData = new FormData();
      formData.append("openid", openid);
      formData.append("pageNo", page);
      formData.append("type", type);
      steamApi.getSteamAssignmentList(formData).then(function(res) {
        that.refreshing = false;
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var result = resData.data;
          if(result.length>0)
          {
            result.forEach((item) => {
              switch (item.bpmStatus) {
                case "1":
                  item.bpmStatusType = 'danger';
                  item.bpmStatusTitle = '作业中';
                break;
                case "2":
                  item.bpmStatusType = 'warning';
                  item.bpmStatusTitle = '待签字确认';
                break;
                case "3":

                  if(item.isRefund && item.isRefund ==="2"){
                    item.bpmStatusType = 'default';
                    item.bpmStatusTitle = '已退款';
                  }else if(item.isRefund && item.isRefund ==="1"){
                    item.bpmStatusType = 'danger';
                    item.bpmStatusTitle = '退款中';
                  }else {
                    item.bpmStatusType = 'success';
                    item.bpmStatusTitle = '已完成';
                  }
                break;
              }
              that.steamAssignmentList.push(item);
            });
            console.log('steamAssignmentList',that.steamAssignmentList);
            
          }
          else{
            that.finished = true;
            that.loading = false;
          }
          
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });

    },
    changeTabs()
    {
      var type = "all";
      switch (this.active) {
        case 0://所有
          type = "all";
        break;
        case 1:
          type = "working";
        break;
        case 2:
          type = "finish";
        break;
      }
      this.getSteamAssignmentList(type,1);
    },
    onRefresh() {
      this.page = 1;
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.changeTabs();
    },
    loadInfo()
    {
      var type = "all";
      switch (this.active) {
        case 0://所有
          type = "all";
        break;
        case 1:
          type = "working";
        break;
        case 2:
          type = "finish";
        break;
      }
      this.page ++ ;
      this.getSteamAssignmentList(type,this.page);
    },
  }
}
</script>
<style lang="scss" scoped>
.steam-list-wrapper {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 50px;
}

.steam-list-content {
  padding: 12px;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  margin: 12px 0;
  border-radius: 12px;
}
</style>
